<template>
    <section>
	    <section class="order-main">
	        <div class="content">
	            <div class="order-filter mgtop25">
	                <ul class="order-nav">
	                    <li :class="type=='Untreated'?'nav-item active':'nav-item'" @click="type='Untreated';initData(1);">未处理订单 <span class="count">{{total||''}}</span></li>
	                    <li :class="type=='New'?'nav-item active':'nav-item'"  @click="type='New';initData(1);">今日新订汇总 <span class="count">{{totalNew||''}}</span></li>
	                    <li :class="type=='TodayCheckIn'?'nav-item active':'nav-item'"  @click="type='TodayCheckIn';initData(1);">今日入住汇总 <span class="count">{{totalToday||''}}</span></li>
	                    <!-- <li :class="type=='totalAll'?'nav-item active':'nav-item'"  @click="type='totalAll'">所有订单 <span class="count">{{totalAll}}</span></li> -->
	                    <li :class="type=='allOrder'?'nav-item active':'nav-item'" @click="type='allOrder'">全部订单<span class="count">{{totalAll||''}}</span></li>
                      <li v-if="type!='allOrder'" class="upDate" @click="initData(1);">刷 新</li>
	                    <!-- <li class="nav-item">包房名单</li> -->
	                </ul>
	                <div class="filter-form" v-if="type=='allOrder'">
	                    <div class="filter-box">
	                        <div class="filter-item">
	                            <label class="item-title">日期选择：</label>
	                            <select class="item-input" v-model="DateType">

	                            	<option value="1">预订时间</option>
	                            	<option value="2">入住时间</option>
	                            </select>
	                            <!-- <input class="item-input" type="text" v-model="DateType" /> -->
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">客人名称：</label>
	                            <input class="item-input" type="text" v-model="CustName" />
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">状态：</label>
	     	                    <select class="item-input" v-model="OrderStatus">
	     	                    	<option value="">全部</option>
	                            	<option value="0">未读</option>
	                            	<option value="1">已读未处理</option>
	                            	<option value="2">接受</option>
	                            	<option value="3">拒绝</option>
	                            </select>
	                        </div>
	                    </div>
	                    <div class="filter-box">
	                        <div class="filter-item">
	                            <label class="item-title">起止时间：</label>
	                            <div class="date-input ">
	                                <div class="date-box " @click="calendar.show=true">
	                                    <input class="item-date" type="text" v-model="DateFrom"  />
	                                </div>
	                                 <calendar v-if="calendar.show" :zero="calendar.zero" :lunar="calendar.lunar" :value="calendar.value" :begin="calendar.begin"  @select="calendar.select"></calendar>


	                                <div class="date-box"  @click="calendar2.show=true">
	                                    <input class="item-date" id="dateEnd21"  type="text" v-model="DateTo"/>
	                                </div>
	                            	<calendar style="margin-left:133px" v-if="calendar2.show" :zero="calendar2.zero" :lunar="calendar2.lunar" :value="calendar2.value" :begin="calendar2.begin"  @select="calendar2.select"></calendar>
	                            </div>
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">酒店确认号：</label>
	                            <input class="item-input" type="text" v-model="ConfirmNO"  />
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">订单类型：</label>
	                            <select class="item-input" v-model="OrderType">
	                            	<option value="">全部</option>
	                            	<option value="0">预订单</option>
	                            	<option value="1">变更单</option>
	                            	<option value="2">取消单</option>
	                            	<option value="3">无效单</option>
	                            </select>

	                        </div>
	                    </div>
	                    <div class="filter-box">
	                        <div class="filter-item">
	                            <label class="item-title">订单号：</label>
	                            <input class="item-input" type="text" v-model="OrderNO" />
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">酒店确认人：</label>
	                            <input class="item-input" type="text" v-model="Oper" />
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">酒店名称：</label>
	                            <input class="item-input" type="text" v-model="HotelName" />
	                        </div>
	                    </div>
	                </div>
	                <div class="clear"></div>
	                <div class="search-btn" v-if="type=='allOrder'" @click="postData(1)">查询</div>
	            </div>
	        </div>
	    </section>
	    <section class="order-content">
	        <div class="content">
	            <table class="order-table" cellspacing="0">
	                <thead>
	                    <tr>
	                        <td width="15%">订单号</td>
	                        <td width="5%">类型</td>
	                        <td width="7%">状态</td>
	                        <td width="17%">酒店名称<br>房型名称</td>
	                        <td width="10%">客人名称</td>
	                        <td width="10%">入住日期<br>离店日期</td>
	                        <td width="5%">房间数</td>
                          <td width="7%">总间夜数</td>
													<td width="7%">确认号</td>
	                        <td width="8%">申请时间</td>
	                        <td width="4%">操作</td>
	                        <td width="4%">日志</td>
	                    </tr>
	                </thead>
	                <tbody>
	                	<tr v-for="item in list " >
	                		<td>
	                			<span class="order-new-icon swing" v-if="item.OrderStatesId==0" ></span>
	                			{{item.PurchaseOrderId}}<br>{{item.PaymentTypeStr}}
	                		</td>
	                		<td>
	                			<span v-if="item.OrderTypeId==0" style="color:#ff3856">{{item.OrderType}}</span>
	                			<span v-if="item.OrderTypeId!=0">{{item.OrderType}}</span>
	                		</td>
	                		<td>
	                			<span v-if="item.OrderStatesId==0" style="color:#999999"> {{item.OrderStates}}</span>
	                			<span v-if="item.OrderStatesId!=0" > {{item.OrderStates}}</span>
	                		</td>
	                		<td>{{item.HotelName}}<br>{{item.RoomName}}</td>
	                		<td width="10%">{{item.GuestName}}</td>
	                		<td>{{item.CheckIn}}<br>{{item.CheckOut}}</td>
	                		<td>{{item.RoomNum}}</td>
                      <td>{{getDaysSize(item.CheckIn,item.CheckOut)*item.RoomNum}}</td>
											<td>{{item.ConfirmNo||'暂无'}}</td>
	                		<td>{{item.CreatTime.split(" ")[0]}}<br>{{item.CreatTime.split(" ")[1]}}</td>
	                	    <td><a class="check" @click="toOrderEdit(item)">查看</a></td>
	                        <td><a @click="orderView(item)">日志</a></td>
	                	</tr>
										<tr v-if="!list||list.length<1" >
											<td colspan="11" class="textCenter">没有相关数据</td>
										</tr>
	                </tbody>
	            </table>
	            <div class="paging-list" v-if="list&&list.length>0">
								<paginate
										:page-count="pageCount"
										:page-range="2"
										:margin-pages="1"
										:force-page="page"
										:click-handler="toGetData"
										:prev-text="'<<上一页'"
										:next-text="'下一页>>'"
										:container-class="'pagination'"
										:page-class="'page-item'">
								</paginate>
	              <span class="total-page">共{{pageCount}}页</span>
	              <div class="clear"></div>
	            </div>
	        </div>
	    </section>
	    <section class="section-footer">
	        <div class="content">
	            <p>预订及售后电话（酒店专用）：020-2214 6801  国内产品：0755-82365588-1  香港产品：0755-82365588-2  海外产品：0755-82365588-3  澳门产品：0756-8281308</p>
	            <p>Copyright2013-2017,cnbooking.net.All rights reserved. <a href="https://beian.miit.gov.cn/">粤ICP备09018804号</a>  <a href="https://beian.mps.gov.cn/#/query/webSearch"> <img style="vertical-align: sub;" src="./../../assets/images/element.png" alt=""> 粤公网安备 44030302000401号</a></p>
	        </div>
	    </section>
	    <OrderView :vdata="orderViewData" ></OrderView>
        <div class="calendar-dialog" v-if="calendar.show">
            <div class="calendar-dialog-body">

            </div>
        </div>
    </section>
</template>

<script>
import Paginate from "vuejs-paginate";
import OrderView from "./OrderView.vue";
import Calendar from "./../../common/calendar/calendar.vue"; //日期选择器
export default {
  name: "order",
  components: {
    Paginate,
    OrderView,
    Calendar
  },
  data() {
    return {
      // hotelName: this.dao.get("HotelName"),
      list: [],
      type: "Untreated",
      page: 0,
      pageSize: 10,
      pageCount: 1,
      total: 0,
      totalNew: 0,
      totalToday: 0,
      totalAll: 0,
      orderViewData: {},
      DateType: 1,
      DateFrom: this.getDate(-90),
      DateTo: this.getDate(0),
      OrderNO: "",
      CustName: "",
      ConfirmNO: "",
      Oper: "",
      OrderStatus: "",
      OrderType: "",
      HotelName: "",
      calendar: {
        display: "",
        show: false,
        zero: true,
        begin:'', //默认日期
        value: this.getDate(-90).split("-"),
        lunar: false, //显示农历
        select: value => {
          if (!value) {
            this.calendar.show = false;
            return;
          }
          this.DateFrom = value.join("-");

          this.calendar.value = value;
          this.calendar2.begin = value;

          this.calendar2.value = value;
          this.DateTo = "";

          this.calendar2.show = true;

          this.calendar.show = false;
          var end = document.getElementById("dateEnd21");
          end.focus();
        }
      },
      calendar2: {
        display: "",
        show: false,
        zero: true,
        begin: '', //默认日期
        value: this.getDate(0).split("-"),
        lunar: false, //显示农历
        select: value => {
          if (!value) {
            this.calendar2.show = false;
            return;
          }
          this.DateTo = value.join("-");

          this.calendar2.value = value;
          this.calendar2.show = false;
          // this.calendar.display=value.join("-");
        }
      }
    };
  },
  watch: {
    type(val) {
      if (val == "allOrder") {
        this.postData(1);
      } else {
        // this.initData(1);
      }
    }
  },
  methods: {
    toGetData(page) {
      if (this.type == "allOrder") {
        this.postData(page);
      } else {
        this.initData(page);
      }
    },
    //初始化数据，page为页码
    initData(page) {
      var that = this;
      that.page = page - 1;
      var params = {
        type: that.type,
        page: page,
        pageSize: that.pageSize
      };
      that
        .getRequest({
          url: that.Api.getOrderList,
          params: params
        })
        .then(res => {
          that.list = res.Result;
          if (that.type == "Untreated") {
            that.total = res.Total;
          } else if (that.type == "New") {
            that.totalNew = res.Total;
          } else if (that.type == "totalAll") {
            that.totalAll = res.Total;
          } else {
            that.totalToday = res.Total;
          }
          that.pageCount = Math.ceil(res.Total / 10);
        });
    },
    //初始化数据，page为页码
    postData(page) {
      var that = this;
      that.page = page - 1;
      var params = {
        page: page,
        DateType: that.DateType,
        DateFrom: that.DateFrom.split("-").join("/"),
        DateTo: that.DateTo.split("-").join("/"),
        OrderNO: that.OrderNO,
        CustName: that.CustName,
        ConfirmNO: that.ConfirmNO,
        Oper: that.Oper,
        OrderStatus: that.OrderStatus,
        OrderType: that.OrderType,
        HotelName: that.HotelName
      };
      that
        .postRequest({
          url: that.Api.getOrderList,
          params: params
        })
        .then(res => {
          that.list = res.Result;
          if (that.type == "Untreated") {
            that.total = res.Total;
          } else if (that.type == "New") {
            that.totalNew = res.Total;
          } else if (that.type == "allOrder") {
            that.totalAll = res.Total;
          } else {
            that.totalToday = res.Total;
          }
          that.pageCount = Math.ceil(res.Total / 10);
        });
    },
    orderView(item) {
      this.orderViewData = item;
      this.$nextTick(function() {
        this.$set(item, "isShow", item.isShow ? false : true);
      });
    },
    toOrderEdit(item) {
      this.dao.set("ebID", item.EB_Id);
      this.dao.set("VerCol", item.VerCol);
      this.$router.push("/orderEdit");
    }
  },
  mounted() {
    this.initData(1);
    // 当页面可见性发生变化时，如果当前路由为 '/order' 则更新页面
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible" && this.$route.path === "/order") {
        if (this.type == "allOrder") {
          this.postData(1);
        } else {
          this.initData(1);
        }
      }
    });
  },
  activated() {
    if (this.type == "allOrder") {
      this.postData(this.page + 1);
    } else {
      this.initData(this.page + 1);
    }
  }
};
</script>
<style scoped>
.upDate{
    float: right;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-right: 10px;
    cursor: pointer;
    color: #fff;
    background: #4584f5;
}
</style>






// WEBPACK FOOTER //
// src/components/order/Order.vue